/* #104 — desktop pack-overview, Tray A (founder-approved mockup).
   NEW FILE. Own module: reads/mutates pack state ONLY through the read-only
   ltBapDesktopApi seam lt-build-a-pack.js now exposes (see that file's own
   comment for why the seam exists — Tray A's per-row [-N+] stepper is a NEW
   interaction, unlike the rejected spike which only supported tap-to-remove).

   Kept mechanics from the spike (proven, reused as-is):
     - the tray's own [data-lt-pill] / [data-lt-scrim] click handlers
       (openTray/closeTray) drive open/close — this module fires .click() on
       those existing elements instead of touching state.trayOpen directly;
     - the existing .lt-bap__scrim for click-away (its own #104 note lives
       in lt-bap-desktop-tray.css);
     - isDesktop() mirrors the CSS file's own @media boundary exactly
       (matrix row 7).

   New in this file (Tray A only): rendering the panel's per-item ROWS
   (name/meta/qty stepper/line total/remove), the journal-in-panel row, and
   the tier line — none of that existed in the spike, which only reused the
   mobile thumb grid for its (rejected) expanded state. */
(function () {
  'use strict';

  // #104: unlike the rejected spike, this module has a real cross-script
  // dependency (root.ltBapDesktopApi, set by lt-build-a-pack.js's own
  // top-level code). The section places this file's <script defer> BEFORE
  // lt-build-a-pack.js's own tag (the render call sits inside the tray
  // markup; that script tag lives further down the section) — deferred
  // scripts run in DOCUMENT order, so this module's code would otherwise
  // execute before the API it depends on exists. Always wait for
  // DOMContentLoaded (never the readState-is-already-past-loading shortcut
  // the spike used) — browsers guarantee it fires only after EVERY deferred
  // script has finished running, regardless of their relative tag order, so
  // this is correct no matter which one loads first.
  function ready(fn) {
    document.addEventListener('DOMContentLoaded', fn);
  }

  // #143 round 2: this file's own runtime strings ("Remove from pack", the
  // per-row stepper's Fewer/More, the journal row's "Change") were still
  // hardcoded English — round 1 named this file as a gap. Reads the SAME
  // `[data-lt-type-labels]` bridge lt-build-a-pack.js already parses (this
  // module only ever loads alongside it, on the build-a-pack page), so no
  // second script tag is needed — section-lt-build-a-pack.liquid's existing
  // "strings" object just grows the keys this file needs. Absent node / bad
  // JSON / missing key -> the English fallback, i.e. today's behaviour.
  var ltTrayStrings = {};
  (function parseTrayStrings() {
    // #143 round 3: the builder page renders TWO [data-lt-type-labels] tags —
    // cart-drawer.liquid's (overlay group, BEFORE <main>) and the builder's.
    // A bare querySelector returns the drawer's one first, so this tray read
    // the drawer's string map and every builder-only key fell back to
    // English on /nl. Ask for our own tag by owner; the bare selector stays
    // as a fallback for any page that only has one bridge.
    var node = document.querySelector('[data-lt-type-labels][data-lt-bridge="bap"]') ||
      document.querySelector('[data-lt-type-labels]');
    if (!node) return;
    var parsed;
    try { parsed = JSON.parse(node.textContent); } catch (e) { return; }
    if (parsed && parsed.strings) ltTrayStrings = parsed.strings;
  })();
  function LT(key, fallback) {
    var v = ltTrayStrings[key];
    if (!v) return fallback;
    // Vera B2 (2026-09-26): Shopify's `t` filter HTML-escapes every non-_html locale
    // value before `json` wraps it, so "you've" arrived as "you&#39;ve" and textContent
    // showed the entity literally. Decode once here; _html keys are real HTML already.
    if (typeof v !== 'string' || v.indexOf('&') === -1 || /_html$/.test(key)) return v;
    var ta = document.createElement('textarea');
    ta.innerHTML = v;
    return ta.value;
  }

  ready(function () {
    var root = document.querySelector('[data-lt-bap]');
    var tray = document.querySelector('[data-lt-tray]');
    var pill = document.querySelector('[data-lt-pill]');
    var scrim = document.querySelector('[data-lt-scrim]');
    var trigger = document.querySelector('[data-lt-dtray-trigger]');
    var triggerThumbs = document.querySelector('[data-lt-dtray-thumbs]');
    var panel = document.querySelector('[data-lt-dtray-panel]');
    var panelCollapse = document.querySelector('[data-lt-dtray-collapse]');
    var panelCount = document.querySelector('[data-lt-dtray-count]');
    var panelRows = document.querySelector('[data-lt-dtray-rows]');
    var panelJournal = document.querySelector('[data-lt-dtray-journal]');
    if (!root || !tray || !pill || !scrim || !trigger || !panel) return; // section without the tray markup

    function isDesktop() {
      // Mirrors the CSS file's own @media (min-width: 990px) boundary
      // exactly (matrix row 7: feature is desktop-only, mobile/tablet gap
      // untouched).
      return window.matchMedia('(min-width: 990px)').matches;
    }
    function isOpen() {
      return tray.classList.contains('is-open');
    }
    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }

    // Single source of truth for both elements' visibility, so a click-away
    // close (scrim) and a button close (trigger/collapse) always land on the
    // same state — see renderTrigger() below for why trigger.hidden can't
    // be a bare "!open" (an empty pack must stay hidden even when closed).
    function syncExpanded() {
      var open = isOpen();
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      renderTrigger();
    }

    function toggle() {
      if (!isDesktop()) return;
      // pill.click()/scrim.click() run openTray()/closeTray() synchronously
      // (lt-build-a-pack.js), which flip state.trayOpen -> render() -> the
      // .is-open class toggle, all complete before .click() returns.
      if (isOpen()) scrim.click();
      else pill.click();
      syncExpanded();
    }

    trigger.addEventListener('click', function () {
      if (!isDesktop()) return;
      toggle();
    });
    if (panelCollapse) panelCollapse.addEventListener('click', function () {
      if (!isDesktop()) return;
      toggle();
    });
    // Click-away: the scrim already closes the tray (lt-build-a-pack.js);
    // this just keeps aria-expanded / the trigger-vs-panel swap correct
    // when the user closes that way instead of via the buttons above.
    scrim.addEventListener('click', function () {
      if (isDesktop()) syncExpanded();
    });

    // ---- rendering (driven by lt-build-a-pack.js's ltBapDesktopApi) ----
    var MAXT = 9; // same cap the rejected spike/mockup used for the collapsed strip

    function renderTrigger() {
      var api = root.ltBapDesktopApi;
      if (!api) return;
      var entries = api.entries(96);
      var journal = api.journal(96);
      var chips = entries.slice(0, MAXT);
      var html = chips.map(function (en) {
        var badge = en.qty > 1 ? '<span class="lt-bap__dthumbbadge">×' + en.qty + '</span>' : '';
        var img = en.image ? '<img class="lt-img-cover" alt="" src="' + en.image + '">' : '';
        return '<span class="lt-bap__dthumb">' + img + badge + '</span>';
      }).join('');
      if (journal) {
        var jimg = journal.image ? '<img class="lt-img-cover" alt="" src="' + journal.image + '">' : '';
        html += '<span class="lt-bap__dthumb lt-bap__dthumb--journal" style="--journal-hex:' + (journal.hex || '') + '">' + jimg + '</span>';
      }
      triggerThumbs.innerHTML = html;
      var more = entries.length - MAXT;
      if (more > 0) triggerThumbs.innerHTML += '<span class="lt-bap__dmore">+' + more + '</span>';
      var has = entries.length > 0 || !!journal;
      trigger.hidden = has ? isOpen() : true;
    }

    function renderPanel() {
      var api = root.ltBapDesktopApi;
      if (!api) return;
      var entries = api.entries(168);
      var count = api.count();
      if (panelCount) panelCount.textContent = '(' + count + ')';

      if (panelRows) {
        panelRows.innerHTML = entries.map(function (en) {
          var img = en.image ? '<img class="lt-img-cover" alt="" src="' + en.image + '">' : '';
          return (
            '<div class="lt-bap__drow" data-key="' + escapeHtml(en.key) + '">' +
              '<span class="lt-bap__drowimg">' + img + '</span>' +
              '<span class="lt-bap__drowbody">' +
                '<span class="lt-bap__drowname">' + escapeHtml(en.label) + '</span>' +
              '</span>' +
              '<span class="lt-bap__drowchip">×' + en.qty + '</span>' +
              '<span class="lt-bap__drowstepper">' +
                '<button type="button" class="lt-bap__drowstepbtn" data-act="dec" aria-label="' + LT('fewer', 'Fewer') + '">−</button>' +
                '<span class="lt-bap__drowstepqty">' + en.qty + '</span>' +
                '<button type="button" class="lt-bap__drowstepbtn" data-act="inc" aria-label="' + LT('more', 'More') + '">+</button>' +
              '</span>' +
              '<span class="lt-bap__drowtotal">' + escapeHtml(en.lineTotal) + '</span>' +
              '<button type="button" class="lt-bap__drowremove" data-act="remove" title="' + LT('remove_from_pack', 'Remove from pack') + '" aria-label="' + LT('remove_from_pack_row_aria', 'Remove {name}').replace('{name}', escapeHtml(en.label)) + '">×</button>' +
            '</div>'
          );
        }).join('');
      }

      // #104 r5 (Nick, reversing r4): the journal deal is visible ON the row
      // again — struck full price (fromPrice) next to the 10%-capped net.
      // #104 r6 (Nick, 2026-08-19): the green tier line below the journal
      // row is removed entirely; the tier cut shows only in the collapsed
      // bar's struck total.
      var journal = api.journal(168);
      if (panelJournal) {
        panelJournal.hidden = !journal;
        if (journal) {
          var jimg = journal.image ? '<img class="lt-img-cover" alt="" src="' + journal.image + '">' : '';
          var from = journal.fromPrice ? '<span class="lt-bap__djfrom">' + escapeHtml(journal.fromPrice) + '</span>' : '';
          panelJournal.innerHTML =
            '<span class="lt-bap__djimg" style="--journal-hex:' + (journal.hex || '') + '">' + jimg + '</span>' +
            '<span class="lt-bap__djbody"><span class="lt-bap__djname">' + escapeHtml(journal.title) + '</span></span>' +
            '<button type="button" class="lt-bap__djchange" data-act="journal-change">' + LT('change', 'Change') + '</button>' +
            '<span class="lt-bap__djtotal">' + from + escapeHtml(journal.price) + '</span>';
        }
      }

    }

    function renderAll() {
      renderTrigger();
      if (isOpen()) renderPanel();
    }

    // Row interactions: qty stepper (inc/dec) and remove. Delegated on the
    // rows container since it is rebuilt wholesale on every render (same
    // pattern lt-build-a-pack.js itself uses for its own delegated lists).
    if (panelRows) panelRows.addEventListener('click', function (e) {
      var api = root.ltBapDesktopApi;
      if (!api) return;
      var btn = e.target.closest ? e.target.closest('[data-act]') : null;
      if (!btn) return;
      var row = btn.closest('.lt-bap__drow');
      var key = row && row.dataset.key;
      if (!key) return;
      if (btn.dataset.act === 'inc') api.inc(key);
      else if (btn.dataset.act === 'dec') api.dec(key);
      else if (btn.dataset.act === 'remove') api.remove(key);
    });
    if (panelJournal) panelJournal.addEventListener('click', function (e) {
      var api = root.ltBapDesktopApi;
      if (!api) return;
      if (e.target.closest && e.target.closest('[data-act="journal-change"]')) api.openJournalQuick();
    });

    // #68 finding 2 precedent (breakpoint crossing): re-sync the trigger-vs-
    // panel swap the instant the 990px boundary is crossed (device rotation,
    // a resized desktop window), not just on the next click/render().
    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 990px)');
      var onBreakpoint = function () { syncExpanded(); renderAll(); };
      if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
      else if (mq.addListener) mq.addListener(onBreakpoint); // Safari <14
    }

    syncExpanded();
    if (root.ltBapDesktopApi) {
      root.ltBapDesktopApi.onRender(renderAll);
      renderAll();
    }
  });
})();
